import { Button } from "@mui/material";
import styled from "styled-components";

export const LeftButton = styled(Button)`
    border-radius: 8px 0px 0px 8px !important;
`;

export const RightButton = styled(Button)`
    border-radius: 0px 8px 8px 0px !important;
`;
